import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-inner">
        <div className="footer-columns">
          <div className="footer-col">
            <h4>Customer Care</h4>
            <ul>
              <li>
                <Link onClick={toTop} to="/shipping">
                  Delivery Information
                </Link>
              </li>
              <li>
                <Link onClick={toTop} to="/returns">
                  Returns Information
                </Link>
              </li>
              <li>
                <Link onClick={toTop} to="/contact">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Privacy & Legal</h4>
            <ul>
              <li>
                <Link onClick={toTop} to="/privacy">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link onClick={toTop} to="/terms">
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Coneect</h4>
            <ul>
              <li>style@boventraix.space</li>
              <li>
                Las Liebres 160B, Las Gaviotas, 96536 Coatzacoalcos, Ver.,
                Mexico
              </li>
            </ul>
          </div>

          <div className="footer-col footer-right">
            <h4>Follow Us On Social Media</h4>
            <div className="socials">
              {/* Instagram */}
              <button
                type="button"
                aria-label="instagram"
                className="social-icon"
              >
                <svg viewBox="0 0 24 24">
                  <path d="M7 2h10a5 5 0 015 5v10a5 5 0 01-5 5H7a5 5 0 01-5-5V7a5 5 0 015-5zm5 6.5A4.5 4.5 0 1016.5 13 4.5 4.5 0 0012 8.5zm5.4-3.9a1.1 1.1 0 11-1.1 1.1 1.1 1.1 0 011.1-1.1z" />
                </svg>
              </button>

              {/* Pinterest */}
              <button
                type="button"
                aria-label="pinterest"
                className="social-icon"
              >
                <svg viewBox="0 0 24 24">
                  <path d="M12 2C6.5 2 2 6.5 2 12c0 4 2.4 7.4 5.8 8.8-.1-.7-.2-1.9 0-2.7.2-.8 1.4-5.4 1.4-5.4s-.3-.6-.3-1.6c0-1.5.9-2.6 2-2.6.9 0 1.3.7 1.3 1.6 0 .9-.6 2.3-.9 3.6-.3 1 0 1.9.7 1.9 1 0 1.8-1.3 2.4-2.6.7-1.8 1.9-5 1.9-6.7 0-1.6-.9-2.8-2.6-2.8-2 0-3.4 2.3-3.4 4.2 0 .9.3 1.5.3 1.5s-1 4.1-1.2 5.1c-.2.9-.1 2 .1 2.7C9.9 20.7 11 21 12 21c5.5 0 10-4.5 10-9s-4.5-9-10-9z" />
                </svg>
              </button>

              {/* Facebook */}
              <button
                type="button"
                aria-label="facebook"
                className="social-icon"
              >
                <svg viewBox="0 0 24 24">
                  <path d="M22 12a10 10 0 10-11.5 9.9v-7h-2.2v-2.9h2.2V9.1c0-2.2 1.3-3.4 3.3-3.4.9 0 1.8.1 1.8.1v2h-1c-1 0-1.3.6-1.3 1.2v1.5h2.2l-.4 2.9h-1.8v7A10 10 0 0022 12z" />
                </svg>
              </button>

              {/* YouTube */}
              <button
                type="button"
                aria-label="youtube"
                className="social-icon"
              >
                <svg viewBox="0 0 24 24">
                  <path d="M23 7.5s-.2-1.7-.8-2.4c-.8-.8-1.7-.8-2.1-.9C17.1 4 12 4 12 4s-5.1 0-8.1.2c-.4 0-1.3.1-2.1.9C1.2 5.8 1 7.5 1 7.5S.8 9.5.8 11.5v1c0 2 .2 4 .2 4s.2 1.7.8 2.4c.8.8 1.9.8 2.4.9 1.7.2 7.8.2 7.8.2s5.1 0 8.1-.2c.4 0 1.3-.1 2.1-.9.6-.7.8-2.4.8-2.4s.2-2 .2-4v-1c0-2-.2-4-.2-4zM9.75 14.8V8.9l5.2 3-5.2 2.9z" />
                </svg>
              </button>

              {/* TikTok */}
              <button type="button" aria-label="tiktok" className="social-icon">
                <svg viewBox="0 0 24 24">
                  <path d="M21 8.2c-1.5 0-3-.5-4.2-1.5v8.2a6.5 6.5 0 11-6.5-6.5c.4 0 .8 0 1.2.1v3.2a3.3 3.3 0 10 2.3 3.2V2h3c.3 1.3 1 2.6 2.1 3.5 1.1.9 2.4 1.4 3.6 1.5v1.2z" />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div className="footer-divider" />

        <div className="footer-bottom">
          <div className="footer-brand">
            <div className="copyright">COPYRIGHT © 2026 Boventraix</div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
